<div id="dvLoadingScreen" class="text-center full-width-div">
  <img id="imgAppLoading" src="./assets/images/WH-Square-Spinner-200px.gif" alt="Loading..." />
</div>
